import { Arc } from "@evergis/sgis/es/renders/Arc";
import { Coordinates } from "@evergis/sgis/es/baseTypes";
import { EditorPointSymbolParams } from "./ShadowedPointSymbol";

export function createShadowRender(
  position: Coordinates,
  { strokeWidth, shadowColor, shadowSize, size, mapCoordinates }: EditorPointSymbolParams,
) {
  const shadowRadius = (size + strokeWidth + shadowSize) / 2;

  return new Arc(position, {
    fillColor: "transparent",
    strokeColor: shadowColor,
    strokeWidth: shadowSize,
    radius: shadowRadius,
    mapCoordinates,
  });
}

export function createPointRender(
  position: Coordinates,
  { strokeColor, strokeWidth, fillColor, size, mapCoordinates }: EditorPointSymbolParams,
) {
  const radius = size / 2;

  return new Arc(position, {
    fillColor,
    strokeColor,
    strokeWidth,
    radius,
    mapCoordinates,
  });
}
